module.exports = __webpack_public_path__ + "img/ph02.c5eac726.jpg";